import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { FormHelperText, TextField, Select, MenuItem, InputLabel} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {addBRSubdomainProvided} from "../../../actions";
import FormControl from "@material-ui/core/FormControl";
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    const {targetEntityId} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustCreateNewSubdomainProvided} = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {customerInView} = useSelector(({customer}) => customer);

    //Get the domains that are already in the provided part of the state
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

    // console.log("myEntity in BrSubdomainsprovidingtable", myEntity);
    const providedDomains = myEntity ? myEntity.domains : null;
    // console.log("providedDomains", providedDomains)

    const activeProvidedDomains = providedDomains ? Object.values(providedDomains).filter(domain => domain.is_active) : null;

    // console.log("activeProvidedDomains", activeProvidedDomains)

    // const domainMenuItems = providedDomains ? Object.keys(providedDomains).map((keyName, i) => (
    //     <MenuItem value={keyName} key={`menuSelect_${keyName}`}>{providedDomains[keyName].domain}</MenuItem>
    // )) : null;

    const domainMenuItems = providedDomains ? activeProvidedDomains.map((domain, i) => (
        <MenuItem value={domain.id} key={`menuSelect_${domain.id}`}>{domain.domain}</MenuItem>
    )) : null;


  const dispatch = useDispatch();
  
    const [subdomain, setSubdomain] = useState(null);
    const [domainId, setDomainId] = useState('');
    const [comments, setComments] = useState(null);
    const [entityId, setEntityId] = useState(targetEntityId);


    const clearForm = () => {

        setSubdomain("");
        setComments("");
        const tempDomainId = domainId;
        document.getElementById('NewBRSubdomainProvidingForm').reset();
        setDomainId(tempDomainId ? tempDomainId : "");
        document.getElementById('domainId').value = domainId;
    }

  useEffect(() => {
    if(didJustCreateNewSubdomainProvided) {
        clearForm();
    }
  }, [dispatch, didJustCreateNewSubdomainProvided]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {
        // console.log("Firing submit of subdomain.", data)

        dispatch(addBRSubdomainProvided({
            "subdomain": subdomain,
            "domainId": domainId,
            "comments": comments,
            "entityId": entityId,
            customerId: customerInView,
        }));
    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">
            <form id={"NewBRSubdomainProvidingForm"} className={classes.root}>

                <FormControl className={classes.formControl}>
                    <InputLabel
                        id="appModule.newUser.customerId-label"
                        required
                        error={!!errors.customerId}
                    >
                        <IntlMessages id="appModule.newBRDomainProviding.domain"/>
                    </InputLabel>
                    <Select
                        labelId="appModule.newBRDomainProviding.domain"
                        id="domainId"
                        name="domainId"
                        value={domainId}
                        onChange={(event) => setDomainId(event.target.value)}
                        displayEmpty
                        // className={classes.selectEmpty}
                    >
                        {
                            domainMenuItems
                        }
                    </Select>
                    <FormHelperText
                        error={!!errors.domainId}
                    >
                        {errors.domainId? errors.domainId?.message : " "}
                    </FormHelperText>
                </FormControl>
                <br/>

                <TextField
                    label={<IntlMessages id="appModule.newBRSubdomainProviding.subdomain"/>}
                    // fullWidth
                    id="subdomain"
                    name="subdomain"
                    required
                    error={!!errors.subdomain}
                    onChange={(event) => setSubdomain(event.target.value)}
                    defaultValue={subdomain}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.subdomain?.message}
                />

                <h3>Comments (optional)</h3>
                <TextField
                    label={<IntlMessages id="appModule.newBRBusinessShare.comments"/>}
                    fullWidth
                    id="comments"
                    name="comments"
                    // required
                    error={!!errors.comments}
                    onChange={(event) => setComments(event.target.value)}
                    defaultValue={comments}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    // inputRef={register({
                    //     required: "This field is required." ,
                    //     // pattern: /^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i
                    // })}
                    helperText={ errors.comments?.message}
                />
                <br/>
                    <br/>
                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                disabled={!!errors.subdomain || !!errors.domainId}
                                variant="contained" color="primary">
                            <IntlMessages id="form.submit"/>
                        </Button>
                    </div>

            </form>

        </div>
    );

}

export default Form